import { Composer } from "./composer";
import { Game } from "./game";
import { Instrument } from "./instrument";
import { Style } from "./style";
import { User } from "./user";

export class TabSubmission {
    id!: number;
    status!: number;
    name!: string;
    text!: string;
    game: Game | null = null;
    denied_reason: string | null = null;
    requested_game: string | null = null;
    instruments!: Instrument[];
    composers!: Composer[];
    styles!: Style[];
    requested_instruments!: string[];
    requested_composers!: string[];
    requested_styles!: string[];
    user!: User;
    created_at!: string;
    updated_at!: string;
    has_new_moderator_comments!: boolean;
    has_new_tabber_comments!: boolean;
    archived!: boolean;
    media_link: string | null = null;

    static fromObject(obj: Record<string, any>): TabSubmission {
        const tabSubmission = Object.setPrototypeOf(obj, TabSubmission.prototype);
        tabSubmission.user = User.fromObject(tabSubmission.user);
        tabSubmission.game = tabSubmission.game ? Game.fromObject(tabSubmission.game) : null;
        tabSubmission.instruments = tabSubmission.instruments.map(Instrument.fromObject);
        tabSubmission.composers = tabSubmission.composers.map(Composer.fromObject);
        tabSubmission.styles = tabSubmission.styles.map(Style.fromObject);
        return tabSubmission;
    }
}
